import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    q: 'Why is digital marketing important for doctors?',
    a: 'Digital marketing helps doctors establish an impactful presence online, improve patient engagement, build trust, and differentiate from competitors. It allows cost-effective targeting of patients who are actively searching for healthcare services — something traditional marketing cannot match.',
  },
  {
    q: 'What services do you offer?',
    a: 'We offer four core services: Google Business Profile Management to boost local visibility, AI-Powered Websites with a built-in AI assistant for handling enquiries and booking appointments, SEO Services covering local, national, and AI search optimization, and Social Media Marketing across Facebook, Instagram, YouTube, and LinkedIn.',
  },
  {
    q: 'What is included in each package?',
    a: 'Starter ($350/mo) includes Google Business setup, social media with 10-15 posts/month, basic SEO, and directory listings. Growth ($550/mo) adds an AI-powered website with booking and payments, AI assistant, local + national SEO, and a dedicated account manager. Premium ($750/mo) adds paid ads management, advanced AI automation, full SEO with AI search optimization, blog posting, and quarterly growth strategy consultations.',
  },
  {
    q: 'What is the AI Assistant on the website?',
    a: 'Our AI assistant is a smart chatbot built into your website that handles patient enquiries 24/7, provides clinic information like doctor availability and directions, and even books appointments automatically. It is trained on your clinic\'s specific services and specialties.',
  },
  {
    q: 'How long before I see results?',
    a: 'Most clinics start seeing noticeable improvements in online visibility within the first 30-60 days. Significant patient growth typically happens within 3-6 months, depending on your specialty, location, and chosen package.',
  },
  {
    q: 'What are the commitment terms?',
    a: 'Starter and Growth plans require a 3-month commitment, and Premium requires a 6-month commitment. This ensures enough time for our strategies to deliver measurable results. There is also a one-time setup fee ($150 for Starter, $200 for Growth, $250 for Premium).',
  },
  {
    q: 'Can I customize a package?',
    a: 'Absolutely. Our packages are designed as starting points. If you need a custom combination of services, we will create a tailored plan that fits your specific clinic needs and budget. Just reach out for a free consultation.',
  },
  {
    q: 'Do you work with hospitals or only individual doctors?',
    a: 'We work with both. Our packages scale from solo practitioners to multi-location hospital chains. The Premium package is particularly well-suited for larger healthcare organizations seeking comprehensive growth.',
  },
];

const FAQ = () => (
  <section id="faq" className="bg-[#EDE7D9] py-20 lg:py-28" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-6">
      <div className="text-center mb-14">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#8C6330] mb-4">FAQ</p>
        <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight text-[#11181C]">
          Frequently Asked Questions
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((faq, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="bg-white border border-[#D6CEBF] rounded-2xl px-6 overflow-hidden"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="font-heading text-left text-base font-medium text-[#11181C] hover:text-[#1B3F33] py-5 hover:no-underline">
              {faq.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-[#4A5568] leading-relaxed pb-5">
              {faq.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
